._tag_k198m_1 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 15px;
  border-radius: 60px;
  background: #fff;
  box-shadow: 0px 4px 24px 0px rgba(0, 6, 36, 0.08);
  cursor: pointer;
  transition: opacity 0.3s;
  border: 1px solid rgba(0, 0, 0, 0);
  min-height: 34px;
  box-sizing: border-box; }
  ._tagIconEnd_k198m_15 {
    flex-direction: row-reverse; }
  [data-theme="chat-theme-light"] ._tag_k198m_1:hover {
    border: 1px solid #d6e6fe;
    color: #116dff; }
    [data-theme="chat-theme-light"] ._tag_k198m_1:hover span {
      color: #116dff; }

@container chat (max-width: 470px) {
  ._tag_k198m_1 {
    min-height: 28px;
    padding: 0 10px;
    box-shadow: none; }
    [data-theme="chat-theme-light"] ._tag_k198m_1 {
      border: 1px solid rgba(214, 230, 254, 0.2); } }
  [data-theme="chat-theme-dark"] ._tag_k198m_1 {
    background: var(--color-d-03);
    color: #fff; }
    [data-theme="chat-theme-dark"] ._tag_k198m_1:hover {
      opacity: 0.8; }
  ._tagDisabled_k198m_35 {
    pointer-events: none;
    background: #F0F0F0; }
    ._tagDisabled_k198m_35 * {
      color: #cfd1dc !important; }
    [data-theme="chat-theme-dark"] ._tagDisabled_k198m_35 {
      background: var(--color-d-03); }
      [data-theme="chat-theme-dark"] ._tagDisabled_k198m_35 * {
        color: var(--color-d-05) !important; }
